function useMultiSelectField(params) {
    return {
        options: params.options,
        getOptionLabel: params.getOptionLabel,
        parse: params.mapValues,
    };
}
export { useMultiSelectField };
